var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.863,
    height: 23.836,
    viewBox: "0 0 19.863 23.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-pdf",
    d: "M7.939,16.427a.88.88,0,0,1-.884.854H6.231V15.573h.834a.88.88,0,0,1,.884.854Zm4.082-.854h-.834v3.476h.834a.88.88,0,0,0,.884-.854V16.427a.88.88,0,0,0-.884-.854ZM21.863,8.1V18.374A5.472,5.472,0,0,1,16.4,23.836H7.462A5.472,5.472,0,0,1,2,18.374V5.462A5.472,5.472,0,0,1,7.462,0h6.3a5.423,5.423,0,0,1,3.863,1.6l2.642,2.642a5.423,5.423,0,0,1,1.6,3.863ZM9.181,16.427a2.115,2.115,0,0,0-2.125-2.1H5.973a1,1,0,0,0-.993.993v4.41a.612.612,0,0,0,.616.616.619.619,0,0,0,.616-.616V18.523h.834a2.115,2.115,0,0,0,2.125-2.1Zm4.966,0a2.115,2.115,0,0,0-2.125-2.1H10.938a1,1,0,0,0-.993.993v4.41a.565.565,0,0,0,.616.556h1.45a2.115,2.115,0,0,0,2.125-2.1V16.427ZM18.8,14.868A.62.62,0,0,0,18.2,14.4H15.9a.612.612,0,0,0-.616.616v4.777a.612.612,0,0,0,.616.616.619.619,0,0,0,.616-.616V18.006h1.232a.612.612,0,0,0,.616-.616.619.619,0,0,0-.616-.616H16.52V15.642H18.2a.629.629,0,0,0,.606-.467v-.3Zm.079-2.95V8.938H14.911a1.992,1.992,0,0,1-1.986-1.986V2.979H7.462A2.484,2.484,0,0,0,4.979,5.462v6.456h13.9Z",
    transform: "translate(-2)",
    fill: "#ff6036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.0baf5b5c65c3a8694ff87e97f883c3e4.svg";
export { ForwardRef as ReactComponent };